export default "__VITE_ASSET__BpTSjrTb__"